<template>
    <div>
        <!-- TITLE -->
        <v-flex pa-3>
            <h3 class="font-weight-regular mb-2">Agregar filtros</h3>
            <v-divider/>
        </v-flex>

        <!-- SPECIALTIES -->
        <v-flex xs12 pl-3 pr-3>
            <v-subheader class="pl-0">Especialidad</v-subheader>
            <service-picker
                ref="specialtySelector"
                v-on:change="onSpecialtyChange"
                multiple
                type="specialty"
            />
        </v-flex>

        <!-- REPUTATION -->
        <v-flex xs12 pl-4 pr-4 v-if="false">
            <v-subheader class="pl-0">Reputación</v-subheader>
            <v-range-slider
                :value="[1, 5]"
                :thumb-size="24"
                thumb-label="always"
                v-model="reputationFilter"
                always-dirty
                min="1"
                max="5"
                ticks="always"
            >
                <template v-slot:thumb-label="props">
                    <span>{{ props.value }}</span>
                </template>
            </v-range-slider>
        </v-flex>

        <v-divider/>

        <!-- BUTTONS -->
        <v-flex text-xs-center mt-3>
            <v-btn
                :disabled="!hasFilters"
                @click="clearAllFilters"
                small round outline
                color="accent"
            >
                <v-icon class="mr-1" small>clear</v-icon>
                Quitar filtros
            </v-btn>
            <v-btn
                :disabled="!hasFilters"
                @click="applyFilters"
                small round outline
                color="primary"
            >
                <v-icon class="mr-1" small>check</v-icon>
                Aplicar
            </v-btn>
        </v-flex>
    </div>
</template>

<script>
import ServicePicker from "@/components/providers/ServicePicker";

export default {
    name: "AccountsFilter",
    components: {ServicePicker},
    props: {
        hasFilters: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        onSpecialtyChange(specialty) {
            this.$emit('specialties', specialty)
        },
        clearAllFilters() {
            this.$emit('clear')
        },
        applyFilters() {
            this.$emit('apply')
        },
    }
}
</script>

<style scoped>

</style>